/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import axios from "axios";
import API_BASE_URL from "./config";

export default function EmployeeAttendance() {
  const [records, setRecords]       = useState([]);
  const [search, setSearch]         = useState("");
  const [statusFilter, setStatus]   = useState("");
  const [startDate, setStartDate]   = useState("");
  const [endDate, setEndDate]       = useState("");
  const [loading, setLoading]       = useState(false);

  const fetchRecords = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API_BASE_URL}/attendance/send`);
      setRecords(res.data || []);
    } catch (e) { console.error(e); }
    setLoading(false);
  };

  useEffect(() => { fetchRecords(); }, []);

  const handleAction = async (id, status) => {
    try {
      await axios.put(`${API_BASE_URL}/attendance/${id}`, { status });
      fetchRecords();
    } catch (e) { alert("Action failed"); }
  };

  const parseDate = (dateStr) => {
    if (!dateStr) return null;
    const parts = dateStr.split(" ");
    if (parts.length < 3) return null;
    const [datePart, timePart, period] = parts;
    const [day, month, year] = datePart.split("/").map(Number);
    let [h, m, s] = timePart.split(":").map(Number);
    if (period?.toLowerCase() === "pm" && h !== 12) h += 12;
    if (period?.toLowerCase() === "am" && h === 12) h = 0;
    return new Date(year, month - 1, day, h, m, s);
  };

  const filtered = records.filter(r => {
    const q = search.toLowerCase();
    const matchSearch = (r.driverId || "").toLowerCase().includes(q) ||
                        (r.driverName || "").toLowerCase().includes(q) ||
                        (r.vehicleNumber || "").toLowerCase().includes(q);
    const matchStatus = !statusFilter || r.status === statusFilter;
    const rDate = parseDate(r.startTime);
    const matchStart = !startDate || (rDate && rDate >= new Date(startDate));
    const matchEnd   = !endDate   || (rDate && rDate <= new Date(endDate + "T23:59:59"));
    return matchSearch && matchStatus && matchStart && matchEnd;
  });

  const downloadCSV = () => {
    const h = "Driver ID,Name,Vehicle,Start Time,Stop Time,Duration,Shift,Status\n";
    const rows = filtered.map(r =>
      `${r.driverId},${r.driverName},${r.vehicleNumber},${r.startTime},${r.stopTime},${r.duration},${r.shiftDetail || ""},${r.status}`
    ).join("\n");
    const blob = new Blob([h + rows], { type: "text/csv" });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = `attendance_${startDate || "all"}_to_${endDate || "all"}.csv`;
    a.click();
  };

  const S = {
    container: { fontFamily: "Arial, sans-serif", marginLeft: "270px", marginRight: "10px", backgroundColor: "#fff", color: "#000", minHeight: "100%", boxShadow: "0 4px 8px rgba(0,0,0,0.1)" },
    toolbar:   { display: "flex", gap: 10, alignItems: "center", padding: "14px 16px", flexWrap: "wrap" },
    input:     { padding: "8px 10px", border: "1px solid black", borderRadius: 5, fontSize: 13 },
    select:    { padding: "8px 10px", border: "1px solid black", borderRadius: 5, fontSize: 13, background: "#fff" },
    btnYellow: { background: "#FFC107", color: "#000", border: "none", padding: "8px 16px", borderRadius: 5, cursor: "pointer", fontWeight: "bold", fontSize: 13 },
    btnBlack:  { background: "#000", color: "#fff", border: "none", padding: "8px 16px", borderRadius: 5, cursor: "pointer", fontWeight: "bold", fontSize: 13 },
    table:     { width: "100%", borderCollapse: "collapse" },
    th:        { background: "#000", color: "#fff", padding: "14px 12px", textAlign: "center", fontSize: 13, fontWeight: "bold" },
    td:        { border: "1px solid #000", padding: "10px 12px", textAlign: "center", fontSize: 13, color: "#000" },
  };

  const badgeStyle = (status) => ({
    background: status === "Approved" ? "#e6f9ee" : status === "Rejected" ? "#fde8e8" : "#fff8e1",
    color:      status === "Approved" ? "#27ae60" : status === "Rejected" ? "#c0392b" : "#d68910",
    padding: "3px 10px", borderRadius: 10, fontSize: 11, fontWeight: "bold",
  });

  return (
    <div style={S.container}>
      <h2 className="sendo-heading">Attendance Approvals</h2>

      <div style={S.toolbar}>
        <input style={S.input} placeholder="Search Driver ID, Name, Vehicle..." value={search} onChange={e => setSearch(e.target.value)} />
        <select style={S.select} value={statusFilter} onChange={e => setStatus(e.target.value)}>
          <option value="">All Status</option>
          <option>Pending</option>
          <option>Approved</option>
          <option>Rejected</option>
        </select>
        <input style={S.input} type="date" value={startDate} onChange={e => setStartDate(e.target.value)} />
        <input style={S.input} type="date" value={endDate}   onChange={e => setEndDate(e.target.value)} />
        <button style={S.btnYellow} onClick={downloadCSV}>⬇ Download</button>
      </div>

      {loading ? (
        <p style={{ padding: 20 }}>Loading attendance records...</p>
      ) : (
        <div style={{ overflowX: "auto" }}>
          <table style={S.table}>
            <thead>
              <tr>
                <th style={S.th}>Driver ID</th>
                <th style={S.th}>Driver Name</th>
                <th style={S.th}>Vehicle No.</th>
                <th style={S.th}>Start Time</th>
                <th style={S.th}>Stop Time</th>
                <th style={S.th}>Duration</th>
                <th style={S.th}>Shift Type</th>
                <th style={S.th}>Shift Detail</th>
                <th style={S.th}>Status</th>
                <th style={S.th}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filtered.length === 0 ? (
                <tr><td colSpan={10} style={{ ...S.td, color: "#888" }}>No records found</td></tr>
              ) : filtered.map((r, i) => (
                <tr key={r._id} style={{ background: i % 2 === 0 ? "#fff" : "#fafafa" }}>
                  <td style={S.td}>{r.driverId}</td>
                  <td style={S.td}>{r.driverName}</td>
                  <td style={S.td}>{r.vehicleNumber}</td>
                  <td style={S.td}>{r.startTime}</td>
                  <td style={S.td}>{r.stopTime}</td>
                  <td style={S.td}>{r.duration}</td>
                  <td style={S.td}>{r.shiftDetail || "—"}</td>
                  <td style={S.td}>{r.driverShiftLabel || "—"}</td>
                  <td style={S.td}><span style={badgeStyle(r.status)}>{r.status}</span></td>
                  <td style={S.td}>
                    <button style={{ ...S.btnYellow, marginRight: 6, padding: "6px 12px" }}
                      onClick={() => handleAction(r._id, "Approved")}>Approve</button>
                    <button style={{ ...S.btnBlack, marginTop: 4, padding: "6px 12px", width: 82 }}
                      onClick={() => handleAction(r._id, "Rejected")}>Reject</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
